import {TabPane} from 'iview'
import Badge from '../widgets/badge'

export default {
    name: 'v-tab-data-grid-item',
    inject: ['tab'],
    components: {
        TabPane,
        Badge
    },
    provide () {
        return {
            tabItem: this
        }
    },
    props: {
        label: {
            type: String
        },
        name: {
            type: String,
            required: true
        },
        nums: {
            type: [String, Number]
        }
    },
    data () {
        return {
            dataGrid: null,
            show: false
        }
    },
    render () {
        const { nums, label, $slots, renderBadge, name, show } = this
        return (
            <TabPane label={nums != 'undefined' ? () => renderBadge(this) : label} name={name}>{show ? $slots.default : ''}</TabPane>
        )
    },
    created () {
        this.tab.add(this)
    },
    beforeDestroy () {
        if (this.tab) this.tab.pop(this)
    },
    methods: {
        renderBadge (tab) {
            return (
                <div class="tab-data-grid-badge-label">
                    <span>{tab.label}</span>
                    <badge value={tab.nums}/>
                </div>
            )
        },
        setDataGrid (vm) {
            this.dataGrid = vm
        },
        select (reload) {
            if (this.dataGrid) this.dataGrid.select(reload)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/framework/data-grid/tab-item.js